import type { LunimarRealm } from "./lunimarRealms";

interface Props {
  stepIndex: number;
  totalSteps: number;
  realm: LunimarRealm;
}

/**
 * Holographic "energy track" progress bar. Renders the mission path as a
 * series of node pips with a glowing fill behind them.
 */
const HoloProgress = ({ stepIndex, totalSteps, realm }: Props) => {
  const pct = Math.min(100, ((stepIndex + 1) / Math.max(1, totalSteps)) * 100);
  return (
    <div className="relative h-1.5 w-full overflow-hidden rounded-full bg-white/5">
      <div
        className="absolute inset-y-0 left-0 rounded-full transition-[width] duration-500 ease-out lunimar-shimmer"
        style={{
          width: `${pct}%`,
          background: `linear-gradient(90deg, hsl(${realm.secondaryAccent}) 0%, hsl(${realm.primaryAccent}) 60%, hsl(${realm.tertiaryAccent}) 100%)`,
          boxShadow: `0 0 12px hsl(${realm.primaryAccent} / 0.7), 0 0 24px hsl(${realm.primaryAccent} / 0.35)`,
        }}
      />
    </div>
  );
};

export default HoloProgress;